import type { SupportSubscriberNeedsResponse } from "@/.generated/hey/backoffice-backend/types.gen";
import type { SupportSubscriberNeedModel } from "@/domains/support/support-subscriber-need";

import { supportSubscriberNeedCodeSchema } from "@/domains/support/support-subscriber-need";

export function mapSupportSubscriberNeedsResponse(
  response: SupportSubscriberNeedsResponse,
): SupportSubscriberNeedModel[] {
  return response.supportSubscriberNeeds.map((subscriberNeed) => ({
    code: supportSubscriberNeedCodeSchema.parse(subscriberNeed.code),
    name: subscriberNeed.name,
  }));
}
